import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-nova-associacao-auditor',
  templateUrl: './list-nova-associacao-auditor.component.html',
  styleUrls: ['./list-nova-associacao-auditor.component.scss']
})
export class ListNovaAssociacaoAuditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
